var app = angular.module('leonardo');

var DropZoneDirective = function(ConfigThemeService, $timeout) {
  return {
    restrict: 'C',
    scope: {
      zoneColor: '@',
      ngClass: '=?'
    },
    link: function (scope, element) {

      scope.getNgClass = function() {
        if (isEmpty(scope.ngClass)) {
          return '';
        }
        else {
          var classes = '';
          angular.forEach(scope.ngClass, function (value, key) {
            if (value){
              classes += ' ' + key;
            }
          });
          return classes;
        }
      };

      scope.$watch(
        function () {
          return element.attr('class') + scope.getNgClass();
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function() {
        $timeout(function () {
          var color = scope.zoneColor ? ConfigThemeService.getColor(scope.zoneColor) : ConfigThemeService.getColor('secondaryColor', 0.02);
          element.css('background-color', color);
          element.css('color', ConfigThemeService.getColor('tertiaryColor'));
          if (element.closest('.zone-error').length > 0) {
            element.css('border-color', ConfigThemeService.getColor('errorColor'));
          }
          else {
            element.css('border-color', ConfigThemeService.getColor('tertiaryColor'));
          }
        });
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('dropZone', ['ConfigThemeService', '$timeout', DropZoneDirective]);
